<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">

                  <el-row>
                      <el-col :span="6" class="item">
                          <el-form-item label="图标" required prop="icon">
                              <el-upload class="upload-demo"
                                  :action="uploadUrl"
                                  list-type="picture-card"
                                  :data='uploadData'
                                  :show-file-list="false"
                                  :on-success="handleImgSuccess"
                                  style="width:100%;margin-top:40px">
                                  <img v-if="addForm.icon" :src="addForm.icon" fit='cover' style="width: 100%;height: 100%;border-radius: 6px;">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                          </el-form-item>
                      </el-col>
                    <el-col :span="18" class="item">
                      <el-row>
<!--                        <el-col :span="12" class="item">-->
<!--                          <el-form-item label="社区中心" required prop="commandCenterCode">-->
<!--                            <el-select v-model="addForm.commandCenterCode" @change="cmdChange" placeholder="请选择社区" style="width: 100%">-->
<!--                              <el-option-->
<!--                                  v-for="item in arr_comm"-->
<!--                                  :key="item.commandCenterCode"-->
<!--                                  :label="item.name"-->
<!--                                  :value="item.commandCenterCode">-->
<!--                              </el-option>-->
<!--                            </el-select>-->
<!--                          </el-form-item>-->
<!--                        </el-col>-->
                        <el-col :span="12" class="item">
                          <el-form-item label="分类" required prop="trainClassCode">
                            <el-select v-model="addForm.trainClassCode" placeholder="请选择" style="width:100%">
                              <el-option
                                  v-for="item in classList"
                                  :key="item.trainClassCode"
                                  :label="item.name"
                                  :value="item.trainClassCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24" class="item">
                          <el-form-item label="名称" required prop="title">
                            <el-input v-model="addForm.title" placeholder="请输入名称"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="24" class="item">
                      <el-form-item label="描述" required prop="description">
                        <el-input v-model="addForm.description" type="textarea" :rows="5" placeholder="请输入描述"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>


                </el-form>

            </div>
            <div class="modal-footer">
              <el-button @click="closeSelf">取消</el-button>
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getGovernmentCode, getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['arr_comm'],
        data() {
            return {
                loading: false,

                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                addForm:{
                    timeStr:timeStr,
                  sign:'',
                    governmentCode:getGovernmentCode(),
                  //commandCenterCode:'',


                    title:'',
                    icon:'',
                    description:'',
                  trainClassCode:'',

                },

              classList:[],

                rules:{
                  title:[
                      { required: true, message: '请输入名称', trigger: 'blur' },
                  ],
                  description:[
                    { required: true, message: '请输入描述', trigger: 'blur' },
                  ],
                  trainClassCode:[
                    { required: true, message: '请选择分类', trigger: 'blur' },
                  ],
                  icon:[
                    { required: true, message: '请上传图片', trigger: 'blur' },
                  ],
                  commandCenterCode:[
                    { required: true, message: '请选择社区', trigger: 'blur' },
                  ],

                },


            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();

                this.getClassList();
            },

          closeSelf() {
            this.$emit("closeAdd");
          },

          cmdChange(val){
              this.addForm.commandCenterCode = val;

              this.classList = [];
              this.addForm.trainClassCode = '';
              this.getClassList();
          },

          getClassList(){
            this.$axios({
              method: 'post',
              url: this.$shopUrl+'TrainClass/GovList2',
              data: {
                timeStr:timeStr,
                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                governmentCode: getGovernmentCode(),
                //commandCenterCode:this.addForm.commandCenterCode,
              }
            }).then( (response)=> {
              if(response.data.error == 0){
                this.classList = response.data.data.list;
              }else if(response.data.error == 1){
                this.$message(response.data.message);
              }else{
                console.log(response.data.message);
              }

            }).catch(function (error) {
              console.log(error);
            });
          },




            handleImgSuccess(res, file) {
                 console.log(file)
                this.addForm.icon = this.$imgUrl+res.data.path;
            },


          confirm(addForm){
            this.$refs[addForm].validate((valid) => {
              if(valid){
                if(!this.addForm.icon){
                  this.$message({type: 'warning', message: '请上传图标'});
                  return;
                }
                this.addSubmit();
              }else {
                console.log('error submit!!');
                return false;
              }
            })

          },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.icon=this.addForm.icon.replace(this.$imgUrl,'')

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Train/GovAddCmt2",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },


        }
    }


</script>

<style lang="scss" scoped>

</style>
